module.exports = __webpack_public_path__ + "static/img/rank_155.5a30c49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_155.png
// module id = p2KM
// module chunks = 0